/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * application/gzip is the .tar.gz of the code a revision was rendered from
 */
export enum SocialMediaType {
  'video/mp4' = 'video/mp4',
  'image/png' = 'image/png',
  'image/jpeg' = 'image/jpeg',
  'image/webp' = 'image/webp',
  'application/gzip' = 'application/gzip'
}
